import {
  withStyles,
  Switch,
  SwitchProps,
  FormControlLabel,
  FormControlLabelProps,
  makeStyles,
} from "@material-ui/core";
import { Colors } from "../theme/Theme";
import React from "react";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

interface RBSwitchProps extends SwitchProps {
  label?: React.ReactNode;
  labelPlacement?: string;
  formControlStyle?: CSSProperties;
}

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles({
  switchBase: {
    color: Colors.defaultGrey,
    "&.Mui-checked": {
      color: (props: StyleProps) => props.primaryColor,
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: (props: StyleProps) => props.secondaryColor,
    },
  },
});


export const RBSwitch: React.FC<RBSwitchProps> = ({
  label,
  labelPlacement,
  formControlStyle,
  ...props
}) => {
  const { checked, onChange, name, ...rest } = props;

   const primaryColor =
    localStorage.getItem("primaryColor") ?? Colors.themeDarkBlue;
  const secondaryColor =
    localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue;

  const classes = useStyles({ primaryColor, secondaryColor });

  return (
    <FormControlLabel
      style={formControlStyle}
      control={
          <Switch
          classes={{
            switchBase: classes.switchBase,
          }}
          checked={props.checked}
          onChange={props.onChange}
          name={props.name}
          {...props}
        />
      }
      label={label}
      labelPlacement={labelPlacement === "start" ? "start" : "end"}
    />
  );
};
